import { computed, ssrRef, useContext } from '@nuxtjs/composition-api';
import {useVSFContext} from '@vue-storefront/core';

export const useApplication = () => {
  const { $softgarden } = useVSFContext();
  const response = ssrRef([], 'useJobs-jobs');
  const loading = ssrRef(false, 'useJobs-loading');
  const error = ssrRef({search: null}, 'useJobs-error');

  const getUserAccessToken = async (params) => {
    return  await $softgarden.api.getUserAccessToken(params);
  };

  const createApplicationByJobId = async (params) => {
    try {
      loading.value = true;
      error.value.search = null;

      response.value = await $softgarden.api.startApplication(params);
    } catch (err) {
      error.value.search = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    createApplicationByJobId,
    response: computed(() => response),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  };
};
